import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import currencyUomService from "../../services/currencyUomService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const currencyFormSchema = [
  {
    name: "currencyCode",
    label: "Currency Code",
    type: "text",
    placeholder: "e.g. USD",
    validation: { required: true },
  },
  {
    name: "currencyName",
    label: "Currency Name",
    type: "text",
    placeholder: "e.g. US Dollar",
    validation: { required: true },
  },
  {
    name: "symbol",
    label: "Symbol",
    type: "text",
    placeholder: "e.g. $",
    validation: { required: true },
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    defaultValue: true,
  },
];

function CurrencyCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await currencyUomService.createCurrency(values);
      alertService.success("Currency created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Currency">
      <CrudForm
        mode="create"
        schema={currencyFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default CurrencyCreateModal;
